<template>
  <div class="tonal-post">
    <ul class="tonal-post__header">
      <li class="tonal-post__title">
        {{chartTitle}}
      </li>
      <li class="tonal-post__tools" v-if="!dataEmpty">
        <el-button type="text" class="tonal-post__tools-button" :disabled="saveChart" @click="onSave">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <el-button type="text" class="tonal-post__tools-button" v-if="!isEdit" @click="editChart">
          <i class="material-icons color_grey">edit</i>
        </el-button>
      </li>
    </ul>

    <el-card shadow="hover" class="publications-by-source__card" v-loading="pending">
      <tonal-header :chart-name="name"/>
      <template v-if="!dataEmpty">
        <tonal-body
          :data="data"
          :chart-name="name"
          :save-chart="saveChart"
          :title="chartTitle"
          @onSavedChart="handleSaved"
          @onSaveChart="handleSave"
        />
      </template>

      <template v-else>
        {{$t('feed.analytics.tonalPost.noData')}}.
      </template>

    </el-card>
  </div>
</template>

<script>
  // mixins
  import { analytics } from "../../../../../../../mixins/analytics";

  import {
  TRUST_HOURLY, TRUST_DAILY
} from "../../../../../../../store/actions/analytics";

  // components
  import TonalHeader from "./header/TonalHeader";
  import TonalBody from "./body/TonalBody";

  export default {
    name: 'TonalPost',
    data() {
      return {
        chartTitle: this.$t('feed.analytics.tonalPost.title'),
        name: "TonalPost",
        saveChart: false
      };
    },
  methods: {
    isRetro() {
        const retro_max = this.$store.getters.retro_max(this.$route.params.threadId)
        const retrospective = this.$store.getters.retrospective(this.$route.params.threadId)
        let end = new Date(retro_max);
        end.setDate(end.getDate() - 1);
        let condition = retro_max != null && new Date(retro_max) < new Date()
        return condition
        //return [`${condition ? retrospective : this.localPeriod[0].replace(" ", "T")}`, `${condition ? end.toJSON().split('T')[0] : this.localPeriod[1].split(' ')[0]} 23:59:59`.replace(" ", "T")];
    },
  },
  mounted() {
    if (!this.isRetro)
      this.$store.dispatch(TRUST_HOURLY, {chart: this.name, thread: this.$route.params.threadId})
    else
      this.$store.dispatch(TRUST_DAILY, {chart: this.name, thread: this.$route.params.threadId});
  },
    mixins: [
      analytics
    ],
    components: {
      TonalHeader,
      TonalBody,
    }
  };
</script>

<style>
  .tonal-post {
    margin-bottom: 40px;
  }
  .tonal-post__header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .tonal-post__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }
  .tonal-post__tools .material-icons {
    font-size: 16px;
  }
  .tonal-post__tools {
    margin-top: 4px;
    margin-right: 15px;
  }
  .tonal-post__tools-button {
    padding: 0;
    color: #5e6d82;
  }

  .tonal-post__tools-button:hover {
    color: #B3BCCC;
    font-size: 12px;
  }
  @media screen and (max-width: 480px) {
    .publications-by-source__card {
      overflow-x: auto;  }
    .tonal-post__tools {
      display: none;
    }
  }
</style>
